
<script>
export default {
  name: "modalUpdateStreakDate",
  props: {
    visible: { type: Boolean, default: false },
    day: { type: Object, default: null },
    submitting: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  computed: {
    formattedDate() {
      if (!this.day?.date) return "";
      return new Date(this.day.date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
  },
  methods: {
    onHidden() {
      this.$emit("update:visible", false);
      this.$emit("hidden");
    },
    cancel() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>


<template>
  <b-modal
    :visible="visible"
    title="Update Streak"
    size="md"
    centered
    @hidden="onHidden"
  >
    <template v-slot:default>
      <p class="mb-0">
        Update the user's participation to a correct guess on this date. Please note that the user's streak will be recalculated with this change.
      </p>
      <p v-if="day" class="text-muted small mt-2 mb-0">
        Date: {{ formattedDate }}
      </p>
      <p v-if="error" class="text-danger mb-0 mt-2">{{ error }}</p>
    </template>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="cancel">Cancel</b-button>
      <b-button variant="primary" @click="confirm" :disabled="submitting">
        <b-spinner v-if="submitting" small class="me-1" />
        Update
      </b-button>
    </template>
  </b-modal>
</template>



